import React from 'react';
import './modal.css'
class Charger extends React.Component {


    
    render() {
	const {visible, toggleModal, children, style} = this.props
	return (
	    
	    <div  className={['modalContainer', (visible !== undefined  ? (visible ? 'modalVisible' : 'modalHidden') : '')].join(' ')} >
		<div className={'modalToggle'} onClick={toggleModal}></div>
		<div className="modal" style={style}>
		    <div className="closeAction"><i className="fa fa-close" onClick={toggleModal}></i></div>
		    {children}
		</div>
	    </div>)
    }
}

export default Charger;



// WEBPACK FOOTER //
// ./src/components/Modal/index.jsx